import { render, staticRenderFns } from "./LoginHome.vue?vue&type=template&id=14882248"
import script from "./LoginHome.vue?vue&type=script&lang=ts"
export * from "./LoginHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports